import { createAction } from 'typesafe-actions';
import { CalculatedDataResponse } from 'types';

export const updateCalculatedData = createAction('UPDATE_SUMMARY', (payload: CalculatedDataResponse) => payload)<
    CalculatedDataResponse
>();
